export default (total, accounts) => {

    return accounts
        .filter(account => account.availableBalance >= total)
        .map(({ maskedSubAccountNumber, availableBalance, ...account}) => {

            return {
                label: maskedSubAccountNumber,
                value: {
                    ...account,
                    availableBalance: availableBalance.toFixed(2)
                }
            }

        });

};